var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 30,
    viewBox: "0 0 133 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21065)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8384 29.1165V0.886719H33.8855V29.1165H32.8384ZM32.8384 29.1165L31.7389 0.886719H30.6918L31.7878 29.1165H32.8384ZM31.7913 29.1165L29.5923 0.886719H28.5452L30.7442 29.1165H31.7913ZM30.7162 29.1165L27.4073 0.886719H26.3602L29.6552 29.1165H30.7162ZM29.6342 29.1165L25.2433 0.886719H24.1962L28.5836 29.1165H29.6342ZM28.5627 29.1165L23.0653 0.886719H22.0007L27.4981 29.1165H28.5627ZM27.4876 29.1165L20.8559 0.886719H19.7808L26.4126 29.1165H27.4876ZM26.4021 29.1165L18.6115 0.886719H17.5295L25.2887 29.1165H26.4021ZM25.3096 29.1165L16.4056 0.886719H15.3131L24.2171 29.1165H25.3096ZM24.2032 29.1165L14.1438 0.886719H13.0374L23.0618 29.1165H24.2032ZM0.53125 0.886719V29.1165H1.57837V0.886719H0.53125ZM1.57837 0.886719L2.75115 29.1165H3.79827L2.62549 0.886719H1.57837ZM2.62549 0.886719L4.98151 29.1165H6.02863L3.67261 0.886719H2.62549ZM3.69006 0.886719L7.15952 29.1165H8.20665L4.71973 0.886719H3.69006ZM4.76511 0.886719L9.46668 29.1165H10.5138L5.80874 0.886719H4.76511ZM5.81223 0.886719L11.6412 29.1165H12.7093L6.88029 0.886719H5.81223ZM6.85935 0.886719L13.9658 29.1165H15.0443L7.93788 0.886719H6.85935ZM7.93439 0.886719L16.4161 29.1165H17.5051L9.0234 0.886719H7.93439ZM9.01293 0.886719L18.7372 29.1165H19.8402L10.1299 0.886719H9.01293ZM10.1229 0.886719L14.5347 11.4338L21.8646 28.9601L21.9274 29.1165H23.0548L22.9676 28.9099L15.6377 11.3807L11.2538 0.886719H10.1229Z",
    fill: "url(#paint0_linear_1_21065)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.574 21.1748C101.373 23.6091 99.3573 25.6939 96.7743 27.1729C94.1913 28.6519 91.1535 29.4607 88.0343 29.4999C84.915 29.5391 81.8502 28.807 79.2163 27.3935C76.5825 25.98 74.4945 23.9468 73.2088 21.5436C71.2298 17.8873 71.2263 12.1386 73.2088 8.47932C74.4903 6.07187 76.5764 4.03377 79.2104 2.61593C81.8443 1.19808 84.9112 0.46237 88.0334 0.499377C91.1556 0.536385 94.1969 1.34449 96.7828 2.82421C99.3687 4.30392 101.386 6.39067 102.588 8.82755L102.675 8.99871H99.2333L99.1914 8.93379C98.139 7.25468 96.5853 5.83764 94.6846 4.82347C92.7839 3.8093 90.6024 3.23332 88.3568 3.15276C86.1113 3.0722 83.8799 3.48986 81.8844 4.36425C79.8889 5.23864 78.1988 6.5393 76.982 8.137C74.1373 11.8406 74.1373 18.1706 76.982 21.8624C78.1985 23.4602 79.8883 24.761 81.8837 25.6357C83.879 26.5103 86.1103 26.9283 88.3558 26.848C90.6013 26.7677 92.783 26.1921 94.6838 25.1782C96.5847 24.1643 98.1387 22.7475 99.1914 21.0685L99.2333 21.0036H102.675L102.574 21.1748ZM64.434 25.9407V0.886271H67.5753V29.116H63.2961L42.0046 4.27113V29.116H38.8633V0.886271H42.9505L64.434 25.9407ZM117.715 12.9354L128.57 0.883317H132.5L119.68 15.1192L132.287 29.116H128.361L117.715 17.3118L107.073 29.116H103.233L115.739 15.1162L102.923 0.886271H106.853L117.715 12.9354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21065",
    x1: 17.1944,
    y1: 29.2493,
    x2: 17.1944,
    y2: -3.32443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#006EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#006EF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 29,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcxLogo);
export default __webpack_public_path__ + "static/media/ncx-logo.3265e9100b41a916f8705f7c978d1be5.svg";
export { ForwardRef as ReactComponent };